// Toda la configuración cliente-específica vive en `.env` (ver `.env.example`).
// Este archivo no debe contener URLs ni IDs hardcoded de producción.

const url = process.env.REACT_APP_URL || "http://localhost:3000";
const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:8000/";
const apiPost = process.env.REACT_APP_API_POST || apiUrl;

// Azure exige que el redirect_uri coincida EXACTO con lo registrado en la App
// Registration, incluyendo la barra final. Garantizamos la barra acá para
// evitar mismatches cuando alguien la olvida en REACT_APP_URL.
const msalRedirectUri = url.endsWith("/") ? url : url + "/";

const azureTenantId = process.env.REACT_APP_AZURE_TENANT_ID || "";
const azureClientId = process.env.REACT_APP_AZURE_CLIENT_ID || "";
const azureClientSilentId = process.env.REACT_APP_AZURE_CLIENT_SILENT_ID || "";

// Pueden coexistir múltiples providers (ej. Yagabogados → "saml,azure").
// REACT_APP_AUTH_PROVIDERS (plural, coma-separado) gana; si no, se cae al singular legacy.
const _multi = process.env.REACT_APP_AUTH_PROVIDERS;
const _legacy = process.env.REACT_APP_AUTH_PROVIDER;
const enabledProviders = _multi
  ? _multi.split(",").map((p) => p.trim().toLowerCase()).filter(Boolean)
  : _legacy
  ? [_legacy.toLowerCase()]
  : ["azure"];

// `authProvider` queda como el principal (primero de la lista) — usado por
// componentes que necesitan un único valor (ej. el flow post-login).
const authProvider = enabledProviders[0];

const samlLoginUrl =
  process.env.REACT_APP_SAML_LOGIN_URL || `${apiUrl}saml/login`;

const clientName = process.env.REACT_APP_CLIENT_NAME || "CRM";

const authority = azureTenantId
  ? `https://login.microsoftonline.com/${azureTenantId}`
  : "";

if (enabledProviders.includes("azure") && (!azureTenantId || !azureClientId)) {
  console.warn(
    "[Parametros] 'azure' está en AUTH_PROVIDERS pero faltan REACT_APP_AZURE_TENANT_ID o REACT_APP_AZURE_CLIENT_ID"
  );
}

const objetoReturn = {
  loginTokenExceptMessage: "expiro la sesion",
  loginTokenExcept: 999,
  url: url,
  post: apiPost,
  urlApi: apiUrl,
  clientName: clientName,
  authProvider: authProvider,
  enabledProviders: enabledProviders,
  samlLoginUrl: samlLoginUrl,
  msalConfig: {
    auth: {
      clientId: azureClientId,
      authority: authority,
      redirectUri: msalRedirectUri,
      postLogoutRedirectUri: msalRedirectUri,
    },
  },
  msalConfigClientSilentToken: {
    auth: {
      clientId: azureClientSilentId,
      authority: authority,
      redirectUri: msalRedirectUri,
      postLogoutRedirectUri: msalRedirectUri,
    },
  },
};

export default objetoReturn;
